export enum StopMarkerStatus {
  DEFAULT = '',
  SELECTED = 'selected',
  HOVER= 'hover',

  MERGE_DISABLED = 'mergeDisabled',
  MERGE_SELECTED = 'mergeSelected',
  START_DISABLED = 'startDisabled',
  START_SELECTED = 'startSelected',
  END_DISABLED = 'endDisabled',
  END_SELECTED = 'endSelected',
  INFLEXION_DISABLED = 'inflexionDisabled',
  INFLEXION_SELECTED = 'inflexionSelected',
  ALTERNATIVES_DISABLED = 'alternativesDisabled',
  ALTERNATIVES_SELECTED = 'alternativesSelected',
  DEMAND_DEFAULT = 'demandDefault',
  DEMAND = 'demand',
  DEMAND_DISABLED = 'demandDisabled',
  DEMAND_SELECTED = 'demandSelected',
}